import React from 'react';

import CheckBox from 'components/shared/FormAdapters/FormDefault/CheckBox';
import CheckBoxGroup from 'components/shared/FormAdapters/FormDefault/CheckBox/Group';
import ColorInput from 'components/shared/FormAdapters/FormDefault/ColorInput';
import DateInput from 'components/shared/FormAdapters/FormDefault/DateInput';
import FileInput from 'components/shared/FormAdapters/FormDefault/FileInput';
import FileLogoInput from 'components/shared/FormAdapters/FormDefault/FileLogoInput';
import InlineSelect from 'components/shared/FormAdapters/FormDefault/InlineSelect';
import Input from 'components/shared/FormAdapters/FormDefault/Input';
import InputGroup from 'components/shared/FormAdapters/FormDefault/Input/Group';
import MaskedInput from 'components/shared/FormAdapters/FormDefault/MaskedInput';
import PasswordInput from 'components/shared/FormAdapters/FormDefault/PasswordInput';
import RadioButton from 'components/shared/FormAdapters/FormDefault/RadioButton';
import RadioGroup from 'components/shared/FormAdapters/FormDefault/RadioButton/Group';
import RateInput from 'components/shared/FormAdapters/FormDefault/RateInput';
import ReactSelect from 'components/shared/FormAdapters/FormDefault/ReactSelect';
import SwitchInput from 'components/shared/FormAdapters/FormDefault/SwitchInput';
import TagsInput from 'components/shared/FormAdapters/FormDefault/TagsInput';
import TextArea from 'components/shared/FormAdapters/FormDefault/TextArea';
import TimePicker from 'components/shared/FormAdapters/FormDefault/TimePicker';

import WYSIWYGInput from '../WYSIWYGInput';
import styles from './index.module.css';

const defaultProps = {
  labelText: undefined,
};

const FormInput = ({ type, labelText, fieldTipsRef, ...rest }) => {
  const inputProps = rest;

  if (type === 'checkbox') {
    return (
      <CheckBox {...inputProps} noMargin>
        {labelText}
      </CheckBox>
    );
  }

  if (type === 'checkboxGroup') {
    return <CheckBoxGroup {...inputProps} />;
  }

  if (type === 'radio') {
    return (
      <RadioButton {...inputProps} noMargin>
        {labelText}
      </RadioButton>
    );
  }

  if (type === 'radioButtonGroup') {
    return <RadioGroup {...inputProps} />;
  }

  if (type === 'select') {
    return <ReactSelect {...inputProps} />;
  }

  if (type === 'asyncSelect') {
    return <ReactSelect {...inputProps} async />;
  }

  if (type === 'creatableSelect') {
    return <ReactSelect {...inputProps} creatable />;
  }

  if (type === 'textarea') {
    return <TextArea {...inputProps} />;
  }

  if (type === 'inputGroup') {
    return <InputGroup {...inputProps} />;
  }

  if (type === 'password') {
    return <PasswordInput fieldTipsRef={fieldTipsRef} {...inputProps} />;
  }

  if (type === 'tags') {
    return <TagsInput {...inputProps} />;
  }

  if (type === 'fileLogo') {
    return <FileLogoInput {...inputProps} />;
  }

  if (type === 'file') {
    return <FileInput {...inputProps} />;
  }

  if (type === 'rate') {
    return <RateInput {...inputProps} />;
  }

  if (type === 'color') {
    return <ColorInput {...inputProps} />;
  }

  if (type === 'inlineSelect') {
    return <InlineSelect {...inputProps} />;
  }

  if (type === 'mask') {
    return <MaskedInput {...inputProps} />;
  }

  if (type === 'editor') {
    return <WYSIWYGInput {...inputProps} />;
  }

  if (type === 'date') {
    return <DateInput {...inputProps} />;
  }

  if (type === 'time') {
    return <TimePicker {...inputProps} />;
  }

  if (type === 'switch') {
    return <SwitchInput fieldTipsRef={fieldTipsRef} {...inputProps} />;
  }

  return <Input type={type} {...inputProps} />;
};

FormInput.defaultProps = defaultProps;
export default FormInput;
